import script from "./FacilityInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityInfoView.vue?vue&type=script&setup=true&lang=js"

import "./FacilityInfoView.vue?vue&type=style&index=0&id=10edcb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10edcb44"]])

export default __exports__